import gql from "graphql-tag";

export const LEAVE_ACCRUAL = gql`
  query leaveAccruals($employee: ID!, $onlyRequestable: Boolean) {
    leaveAccruals(employee: $employee, onlyRequestable: $onlyRequestable) {
      used
      previousBalance
      leavePolicy {
        accrualCalculatedCount
        leaveType {
          id
          name
          icon
          color
          englishName
        }
      }
    }
  }
`;

export const LEAVE_REQUESTS = gql`
  query filterWithPaginateLeaveRequests($criteria: LeaveRequestFilterCriteria!, $pagination: Pagination!) {
    filterWithPaginateLeaveRequests(criteria: $criteria, pagination: $pagination) {
      pageInfo {
        totalElements
        totalPages
        pageNumber
      }
      content {
        id
        leaveType {
          name
          englishName
          color
          icon
        }
        signatureStatus
        leaveRequestStatus
        status
        requestDateTime
        leaveRequestFormURL
        beginLeaveRequestDay {
          date
          duration
        }
        endLeaveRequestDay {
          date
          duration
        }
        approvedDateTime
        requestDateTime
      }
    }
  }
`;

export const LEAVE_APPROVAL = gql`
  query employee($id: ID!) {
    employee(id: $id) {
      pendingApprovalLeaveRequests {
        id
        approver {
          id
        }
        leaveRequest {
          id
          employee {
            firstName
            lastName
            profile {
              imageUrl
            }
            employment {
              branch {
                name
              }
              unit {
                name
              }
            }
          }
          requester {
            firstName
            lastName
            profile {
              imageUrl
            }
          }
          leaveRequestDays {
            date
            duration
            fromTime
            lengthInMinutes
          }
          leaveType {
            name
            englishName
          }

          requestDateTime
          beginLeaveRequestDay {
            date
            fromTime
            lengthInMinutes
          }

          endLeaveRequestDay {
            date
            fromTime
            lengthInMinutes
          }
        }
      }
    }
  }
`;

export const EMPLOYEE_LEAVE_ACCRUALS = gql`
  query leaveAccruals($employee: ID!, $beginDate: String!, $daily: Boolean) {
    leaveAccruals(employee: $employee, beginDate: $beginDate, daily: $daily) {
      previousBalance
      used
      leavePolicy {
        accrualCount
        leaveType {
          id
          name
          englishName
          color
          icon
          weight
          restriction {
            noticePeriod
            includeWeekendsAfter
            includeHolidaysAfter
            includeBreakDaysAfter
            minConsecutive
            maxConsecutive
            durations
            maxExceedLeaveBalance
            includeSaturday
            countAsWorkday
            documents {
              name
              url
            }
            addressRequired
            explanationRequired
            documentRequired
          }
        }
      }
    }
  }
`;

export const FILTER_WORKPLANS = gql`
  query FilterWorkplans($criteria: WorkplanFilterCriteria!) {
    filterWorkplans(criteria: $criteria) {
      date
      breakDay
      assignedShifts {
        id
        shiftType
        beginTime
        endTime
      }
    }
  }
`;

export const FILTER_HOLIDAYS = gql`
  query filterHolidays($criteria: HolidayFilterCriteria!) {
    filterHolidays(criteria: $criteria) {
      id
      name
      color
      code
      halfDay
      countAsOvertime
      date
    }
  }
`;

export const FILTER_LEAVE_REQUEST = gql`
  query filterLeaveRequests($criteria: LeaveRequestFilterCriteria!) {
    filterLeaveRequests(criteria: $criteria) {
      leaveRequestDays {
        id
        date
        duration
        fromTime
        lengthInMinutes
      }
    }
  }
`;

export const EMPLOYEE_MANAGERS = gql`
  query employee($id: ID!) {
    employee(id: $id) {
      leaveSettings {
        leaveApprover
      }
    }
  }
`;

export const HOLIDAYS = gql`
  query filterWithPaginateHolidays($criteria: HolidayFilterCriteria!, $pagination: Pagination!) {
    filterWithPaginateHolidays(criteria: $criteria, pagination: $pagination) {
      pageInfo {
        totalElements
      }
      content {
        id
        color
        name
        date
      }
    }
  }
`;
